import React from 'react';

function About(props) {
    return (
        <div>
            
        </div>
    );
}

export default About;